export default __webpack_public_path__ + "static/media/zscaler-long.4e5ce769.svg";